import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { User } from "./UserType";
import { IconButton } from "@mui/material";
import { Cancel, Check, Edit, Password } from "@mui/icons-material";
import { PaginationModel } from "utils/PaginationType";
import { publishMessage } from "components/ShireMessage";

export const UserTableColumns: (
  getUsers: (page: number, pageSize: number) => void,
  paginationModel: PaginationModel, handleResetPassword: (userId: number) => void,
  handleDisableUser: (userId: number) => Promise<void>,
  handleEnableUser: (userId: number) => Promise<void>
) => GridColDef<User>[] = (getUsers, paginationModel, handleResetPassword, handleDisableUser, handleEnableUser) => [
  { field: 'id', headerName: 'ID', flex: 1, type: 'number', maxWidth: 100 },
  { field: 'username', headerName: 'Tên đăng nhập', flex: 1, type: 'string' },
  { field: 'name', headerName: 'Tên', flex: 1, type: 'string' },
  { field: 'roleName', headerName: 'Vai trò', flex: 1, type: 'string', maxWidth: 100 },
  { field: 'isActive', headerName: 'Trạng thái', flex: 2, type: 'boolean', maxWidth: 100, renderCell: (params) => params.row.isActive ? 'Hoạt động' : 'Không hoạt động' },
  {
    field: 'actions', headerName: 'Hành động', width: 150, type: 'actions', minWidth: 250, getActions: (params: GridRowParams<User>) => {
      return [
      <IconButton key="edit" color="primary" title="Chỉnh sửa" onClick={async () => {
        publishMessage({
          message: 'Edit user not implemented',
          variant: 'warning',
        });
      }}>
        <Edit />
      </IconButton>,
      <IconButton key="reset-password" color="warning" title="Reset mật khẩu" onClick={async () => {
        try {
          await handleResetPassword(Number(params.row.id));
          publishMessage({
            message: 'Đặt lại mật khẩu thành công',
            variant: 'success',
          });
        } catch (error) {
          publishMessage({
            message: 'Đặt lại mật khẩu thất bại',
            variant: 'error',
          });
        }
      }}>
        <Password />
      </IconButton>,
      params.row.isActive ?
       <IconButton key="disable" title="Khóa tài khoản" color="error" onClick={async () => {
        await handleDisableUser(Number(params.row.id));
        getUsers(paginationModel.page, paginationModel.pageSize);
      }}>
        <Cancel />
      </IconButton> :
       <IconButton key="enable" title="Mở khóa tài khoản" color="success" onClick={async () => {
        await handleEnableUser(Number(params.row.id));
        getUsers(paginationModel.page, paginationModel.pageSize);
      }}>
        <Check />
      </IconButton>
    ] as any}
  },
];